export default function getIsVisiblePricing(paymentStatus) {
	return !['paid', 'created', null].includes(paymentStatus);
}
